import { JSX, useState } from 'react';
import './addPage.css';
import AddTodoList from '../todolist/add-todo/addTodoList';
import Note from '../note/note';
import CommnetDots from '../assets/images/gifs/commentDots.gif';
import WindowBar from '../common/windowBar/windowBar';
import MenuButton from '../common/windowMenu/menuButton';
import Events from './events/events';

interface MenuItemProps {
  title: string,
  tab: JSX.Element
}

const AddPage = ({ setClosePage }: { setClosePage: () => void }): JSX.Element => {

  const [selectedItem, setSelectedItem] = useState<MenuItemProps>({
    title: 'Add Todo',
    tab: <AddTodoList/>
  });

  const [isTodo, setIsTodo] = useState(true);
  const [isNote, setIsNote] = useState(false);
  const [isEvent, setIsEvent] = useState(false);

  const TodoTabClicked = () => {
    setIsTodo(true);
    setIsNote(false);
    setIsEvent(false);
    setSelectedItem({title: 'Add Todo', tab: <AddTodoList/>})
  }

  const NoteTabClicked = () => {
    setIsTodo(false);
    setIsNote(true);
    setIsEvent(false);
    setSelectedItem({title: 'Add Note', tab: <Note/>})
  }

  const EventTabClicked = () => {
    setIsTodo(false);
    setIsNote(false);
    setIsEvent(true);
    setSelectedItem({title: 'Add Event', tab: <Events/>})
  }

  return (
    <div className='addPage-outter outter-container'>
      <div className='pixel-container-back'/>
      <div className='pixel-container-top addPage-container'>
        <div className='addPage-inner'>
          <WindowBar IconSrc={CommnetDots} title={selectedItem.title} onClick={setClosePage}/>
          <div className='main-pixel-container page-content'>
            <div className='addPage-menu'>
              <MenuButton title='Todo' isChosen={isTodo} onClick={()=>TodoTabClicked()}/>
              <MenuButton title='Note' isChosen={isNote} onClick={()=>NoteTabClicked()}/>
              <MenuButton title='Event' isChosen={isEvent} onClick={()=>EventTabClicked()}/>
            </div>
            <div className="divider-horizontal"/>
            {selectedItem.tab}
          </div>
        </div>
      </div>
    </div>
  ); 
};
  
export default AddPage;